import { Component, EventEmitter, Output } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule } from '@angular/common';
import { BaseFormControl } from '../base/base-form-control.directive';

@Component({
    selector: 'app-radio',
    standalone: true,
    templateUrl: './radio.component.html',
    styleUrl: './radio.component.scss',
    imports: [MatRadioModule, CommonModule]
})
export class RadioComponent extends BaseFormControl<any> {
  @Output() optionChange = new EventEmitter<any>();

  override writeValue(value: any): void {
    super.writeValue(value);
    this.optionChange.emit(value);
  }

  // If you want to emit only on user interaction, override registerOnChange:
  override registerOnChange(fn: any): void {
    this.onChange = (value: any) => {
      fn(value);
      this.optionChange.emit(value);
    };
  }
}
